// extracted by mini-css-extract-plugin
export default {"tabs":"b1-z","tablist":"c1-z","tablistItem":"d1-z"};